<template>
    <div class="marketing-consent-confirmation-page">
        <div class="marketing-consent-confirmation-page__header">
            <div class="marketing-consent-confirmation-page__header-logo">
                <CompassLogo type="logo" :width="160" />
            </div>
        </div>

        <div class="marketing-consent-confirmation-page__content">
            <div class="marketing-consent-confirmation-page__content-illustration">
                <img src="/ressources/logged/img/illustrations/global-issues.svg" />
            </div>

            <p
                class="marketing-consent-confirmation-page__content-title typographies-display-large"
            >
                {{ labels.title }}
            </p>

            <p
                class="marketing-consent-confirmation-page__content-information typographies-paragraph-x-large-regular"
                v-html="labels.information"
            />

            <div class="marketing-consent-confirmation-page__content-buttons">
                <CompassButton :label="labels.button" size="large" @click="openIntercom" />
            </div>

            <p
                class="marketing-consent-confirmation-page__content-help typographies-paragraph-medium-bold"
            >
                {{ labels.help.text }}
                <CompassLink :label="labels.help.link" link="javascript:;" @click="openIntercom" />
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            labels: {
                title: this.$l10n.__('Une erreur est survenue'),
                information: this.$l10n.__(
                    "Votre inscription n'a pas été prise en compte. Nous vous suggérons de réessayer ultérieurement.%(br)sVous pouvez obtenir de l’aide en cliquant sur le bouton ci-dessous.",
                    {
                        br: '</br>',
                    },
                ),
                button: this.$l10n.__('Contactez l’équipe Sellsy'),
                help: {
                    text: this.$l10n.__("Besoin d'aide ?"),
                    link: this.$l10n.__('Discutez avec nos conseillers'),
                },
            },
        };
    },
    methods: {
        openIntercom() {
            window.Intercom('show');
        },
    },
};
</script>

<style lang="scss" scoped>
.marketing-consent-confirmation-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;

    &__header {
        align-self: flex-start;
    }

    &__content {
        margin: auto;

        &-illustration {
            text-align: center;
            margin-bottom: var(--spacing-5);
        }

        &-title {
            text-align: center;
            color: var(--colors-common-text-brand-secondary-blue, #02016f);
            margin: 0 0 var(--spacing-3);
        }

        &-information {
            text-align: center;
            color: var(--colors-common-text-subtle-default, #565665);
            margin: 0 0 var(--spacing-5);
        }

        &-buttons {
            display: flex;
            justify-content: center;
            margin-bottom: var(--spacing-4);
        }

        &-help {
            text-align: center;
            margin: 0;
            color: var(--colors-common-text-standard-caption, #8c909c);
        }
    }
}
</style>
